import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const leaveTypeService = {
  getAll: async () => {
    return await axios.get(`${domain}/api/LeaveType`, { headers });
  },

  getActive: async () => {
    return await axios.get(`${domain}/api/LeaveType/active`, { headers });
  },
  
  getById: async (id) => {
    return await axios.get(`${domain}/api/LeaveType/${id}`, { headers });
  },

  create: async (payload) => {
    return await axios.post(`${domain}/api/LeaveType`, payload, { headers });
  },

  update: async (id, payload) => {
    console.log("Updating Leave Type ID:", id, "with payload:", payload); // Debug log
    return await axios.put(`${domain}/api/LeaveType/${id}`, payload, { headers });
  },

  delete: async (id) => {
    return await axios.delete(`${domain}/api/LeaveType/${id}`, { headers });
  },


};

export default leaveTypeService;